// imports
import Model from '$dependencies/Model';
import Config from '../../Config';

const FIELDS = {
	uuid: { type: String, default: '', identifier: true },
	firstName: {type: String, default: ''},
	lastName: {type: String, default: ''},
	fullName: {type: String, default: ''},
	joinDate: {type: String, default: '' },
	emailAddress: {type: String, default: ''},
	role: {type: String, default: ''},
	modules: {type: Array, default: () => []},
	incidentNotifications: {type: Boolean, default: false},
	pending: {type: Boolean, default: false},
	active: {type: Boolean, default: false},
	postalCodes: {type: Object, default: () => {}},
	password: {type: String, default: ''},
	currentPassword: {type: String, default: ''},
	buildingPermission: {type: Boolean, default: false}
};

// class definition
export default class UserModel extends Model {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.fields = FIELDS;

		// call super constructor
		super(args);
	}

	fetch(data) {
		this.setConfig('url', `${Config.getUrl('acUsers')}/${this.uuid}`);
		return super.fetch(data);
	}

	fetchOwn(data) {
		this.setConfig('url', `${Config.getUrl('c_user')}`);
		return super.fetch(data);
	}

	post(data) {
		this.setConfig('url', Config.getUrl('acUsers'));
		data = prepareDataForPost(this.toObject(true));
		return super.post(data);
	}

	parse(data) {
		const payload = { ...(data?.data || data || {}) };
		if (payload.incidentNotifications == null && payload.incident_notifications != null) {
			payload.incidentNotifications = payload.incident_notifications;
		}
		if (payload.incidentNotifications != null && typeof payload.incidentNotifications !== 'boolean') {
			payload.incidentNotifications = payload.incidentNotifications === true
				|| payload.incidentNotifications === 1
				|| payload.incidentNotifications === '1'
				|| payload.incidentNotifications === 'true';
		}
		return super.parse(payload);
	}

	patch(data, options = {}) {
		// run super patch
		this.setConfig('url', `${Config.getUrl('acUsers')}/${this.uuid}`);
		return super.patch(prepareDataForPatch(cleanUpPatchFields(data || this.toObject(true), options.fieldsToPatch)));
	}

	patchOwn(data, options = {}) {
		// run super patch
		this.setConfig('url', `${Config.getUrl('c_user')}`);
		return super.patch(prepareDataForPatch(cleanUpPatchFields(data || this.toObject(true), options.fieldsToPatch)));
	}

	resendMail() {
		this.setConfig('url', `${Config.getUrl('acUsers')}/${this.uuid}/resend-activation-mail`);
		return super.post({});
	}
}

function prepareDataForPost(data) {
	delete data.uuid;
	delete data.password;
	delete data.currentPassword;
	delete data.joinDate;
	delete data.fullName;
	//postalcodes post
	const pcObj = {};
	if(data.postalCodes.length) {
		data.postalCodes.forEach(pc => {
			Object.assign(pcObj, {[`${pc}`]: 'full'});
		})
		data.postalCodes = pcObj;
	} else {
		delete data.postalCodes;
	}
	return data;
}

function prepareDataForPatch(data) {
	if (data && data.incidentNotifications != null && typeof data.incidentNotifications !== 'boolean') {
		data.incidentNotifications = data.incidentNotifications === true
			|| data.incidentNotifications === 1
			|| data.incidentNotifications === '1'
			|| data.incidentNotifications === 'true';
	}
	return data;
}

function cleanUpPatchFields(data, fieldsToPatch) {
	if (!fieldsToPatch) return data;
	if (data && fieldsToPatch) {
		for (const field in data) {
			if (!fieldsToPatch.includes(field)) {
				delete data[field];
			}
		}
	}
	return data;
}

